import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DeviceScalingService {
  private readonly MAX_HEIGHT = 800; // Adjust as needed
  private readonly MAX_WIDTH = 500;  // Adjust as needed

  scaleDeviceDimensions(originalWidth: number, originalHeight: number) {
    const aspectRatio = originalWidth / originalHeight;
    
    let newHeight = Math.min(originalHeight, this.MAX_HEIGHT);
    let newWidth = newHeight * aspectRatio;
    
    if (newWidth > this.MAX_WIDTH) {
      newWidth = this.MAX_WIDTH;
      newHeight = newWidth / aspectRatio;
    }
    
    return {
      width: Math.round(newWidth),
      height: Math.round(newHeight),
      scale: newHeight / originalHeight
    };
  }
}